module.exports = __webpack_public_path__ + "img/jhlogo1.1c8493de.png";